export const DESTINATIONS = {
  "mar-del-plata": {
    slug: "mar-del-plata",
    name: "Mar del Plata",
    title: "Alojamientos en Mar del Plata | Alohar",
    metaDescription:
      "Encontrá alojamientos temporarios en Mar del Plata. Departamentos, casas y opciones para vacaciones, escapadas de fin de semana y estadías en la costa atlántica argentina.",
    canonical: "https://alohar.me/destinos/mar-del-plata",
    eyebrow: "Destinos en Argentina",
    h1: "Alojamientos temporarios en Mar del Plata",
    intro:
      "Mar del Plata es el destino de playa más popular de Argentina, con una costa atlántica extensa, un centro urbano activo y una oferta de alojamiento diversa que funciona durante todo el año. Desde departamentos céntricos hasta casas en barrios residenciales, la ciudad tiene opciones para viajes en familia, parejas, grupos de amigos y estadías de trabajo remoto.",
    heroImage: require("../assets/static/backgrounds/2144889281_eb9f460106_b.jpg"),
    searchUrl:
      "/mar-del-plata/search?city=1&cityName=Mar%20del%20Plata",
    highlights: [
      {
        title: "Costa atlántica accesible",
        description:
          "Mar del Plata concentra playas urbanas, balnearios organizados y opciones tranquilas a poca distancia del centro, con alojamientos a precios variados para distintos presupuestos.",
      },
      {
        title: "Turismo activo todo el año",
        description:
          "Más allá de la temporada de verano, la ciudad tiene oferta gastronómica, cultural y de entretenimiento que sostiene el turismo en otoño, invierno y primavera con menos aglomeración.",
      },
      {
        title: "Opciones para cada tipo de viaje",
        description:
          "Desde monoambientes compactos hasta propiedades con capacidad para grupos grandes, Mar del Plata tiene una base de alojamiento heterogénea para viajes cortos o estadías más largas.",
      },
    ],
    sections: [
      {
        title: "Por qué elegir Mar del Plata",
        paragraphs: [
          "Mar del Plata combina la accesibilidad de un destino masivo con la diversidad de una ciudad mediana con vida propia. Tiene aeropuerto, conexión por autopista con Buenos Aires, una zona histórica y un puerto activo que atrae viajeros más allá de la temporada de sol y playa.",
          "La oferta de alojamiento temporario en la ciudad es amplia: departamentos con balcón a pocas cuadras del mar, casas en barrios como Santa Cecilia o Los Troncos, unidades funcionales en el centro para viajeros de trabajo y opciones familiares en zonas más tranquilas como Playa Grande o La Perla.",
        ],
      },
      {
        title: "Tipos de viaje para los que sirve Mar del Plata",
        bullets: [
          "Vacaciones familiares con playa, juegos y gastronomía variada.",
          "Escapadas de fin de semana desde Buenos Aires (a menos de 5 horas en auto).",
          "Estadías de trabajo remoto con conectividad y servicios urbanos.",
          "Viajes en grupo con propiedades grandes y buena relación capacidad-precio.",
          "Turismo cultural y gastronómico en otoño o invierno fuera de temporada alta.",
        ],
      },
    ],
    tips: [
      "Enero y febrero son el pico de temporada: mayor demanda, precios más altos y playas más concurridas.",
      "Noviembre, marzo y abril ofrecen muy buen clima con precios más accesibles y menos gente.",
      "El centro y la zona de Güemes concentran gastronomía, bares y vida nocturna a pie.",
      "Si viajás en invierno, la zona del puerto y el teatro Auditorium tienen propuesta cultural fuerte.",
      "Muchos alojamientos en la zona norte (Punta Mogotes) son más tranquilos y aptos para familias.",
    ],
    faqs: [
      {
        question: "¿Cuándo es mejor temporada para ir a Mar del Plata?",
        answer:
          "El verano (diciembre a febrero) es el período más demandado, con playas llenas y mayor precio. La temporada media (noviembre, marzo y abril) es ideal para disfrutar del clima con menos gente y alojamientos más accesibles. El invierno también tiene atractivos si buscás turismo cultural o gastronómico.",
      },
      {
        question: "¿Qué tipos de alojamientos hay disponibles en Mar del Plata?",
        answer:
          "En Mar del Plata podés encontrar departamentos de distintos tamaños, casas para grupos o familias, monoambientes compactos para viajeros solos o en pareja y opciones en diferentes barrios según el tipo de estadía que buscás.",
      },
      {
        question: "¿Qué distancia hay entre los barrios y la playa?",
        answer:
          "Depende del barrio. Playa Grande, La Perla y el centro están cerca de distintas playas. Si necesitás estar cerca del agua, conviene revisar la ubicación exacta en el mapa antes de reservar.",
      },
      {
        question: "¿En qué zonas conviene buscar alojamiento?",
        answer:
          "El centro y Güemes son buenos para viajeros que quieren gastronomía y actividad a pie. La zona norte (Casino Central) tiene alta densidad de departamentos y queda a poca distancia de las playas más concurridas.",
      },
      {
        question: "¿Se puede ir a Mar del Plata en auto desde Buenos Aires?",
        answer:
          "Sí. La distancia es de aproximadamente 400 km por la Autopista del Atlántico (Ruta 2). En condiciones normales el viaje lleva entre 4 y 5 horas. En temporada alta se recomienda salir en horarios no pico para evitar demoras.",
      },
    ],
    relatedDestinations: [
      { slug: "bariloche", name: "Bariloche" },
      { slug: "iguazu", name: "Iguazú" },
    ],
  },

  bariloche: {
    slug: "bariloche",
    name: "Bariloche",
    title: "Alojamientos en Bariloche | Alohar",
    metaDescription:
      "Encontrá alojamientos temporarios en Bariloche. Cabañas, departamentos y opciones para viajes de montaña, nieve, trekking y turismo lacustre en la Patagonia argentina.",
    canonical: "https://alohar.me/destinos/bariloche",
    eyebrow: "Destinos en Argentina",
    h1: "Alojamientos temporarios en Bariloche",
    intro:
      "Bariloche es uno de los destinos de montaña más reconocidos de Argentina, con lagos, bosques, ski en invierno y trekking en verano. La ciudad combina una oferta turística madura con paisajes únicos y una gama de alojamientos que abarca desde cabañas en zonas boscosas hasta departamentos con vista al lago.",
    heroImage: require("../assets/static/background-abril/hero-alohar.png"),
    searchUrl: "/bariloche/search?city=56&cityName=bariloche",
    highlights: [
      {
        title: "Destino de cuatro estaciones",
        description:
          "Bariloche tiene propuesta turística relevante todo el año: nieve y ski en invierno, hiking y kayak en verano, colores otoñales únicos en otoño y flores de primavera en el Parque Nacional Nahuel Huapi.",
      },
      {
        title: "Entorno natural protegido",
        description:
          "La ciudad limita con el Parque Nacional Nahuel Huapi, lo que significa acceso a senderos, lagos y bosques de ciprés a minutos del centro, un contexto difícil de encontrar en otros destinos del país.",
      },
      {
        title: "Gastronomía y artesanías",
        description:
          "Más allá del turismo de naturaleza, Bariloche tiene una tradición artesanal importante: chocolates, cervezas artesanales y restaurantes con propuesta patagónica que complementan cualquier estadía.",
      },
    ],
    sections: [
      {
        title: "Por qué ir a Bariloche",
        paragraphs: [
          "Bariloche ofrece una experiencia de viaje que combina ciudad y naturaleza sin salir del mismo radio. Podés desayunar en el centro, recorrer un sendero en la tarde y cenar con vista al lago. Esa compacidad es uno de sus mayores atractivos para viajeros que quieren ritmo activo sin logística compleja.",
          "La ciudad tiene aeropuerto con vuelos directos desde Buenos Aires y otras ciudades, lo que facilita el acceso para viajes cortos. También está conectada en ómnibus con destinos patagónicos como Neuquén, Esquel y San Martín de los Andes.",
        ],
      },
      {
        title: "Tipos de viaje para los que sirve Bariloche",
        bullets: [
          "Viajes de nieve y ski en invierno (julio y agosto son el pico de temporada).",
          "Trekking y actividades al aire libre en verano (noviembre a marzo).",
          "Escapadas en pareja con propuesta gastronómica y paisajes lacustres.",
          "Viajes familiares con actividades para distintas edades en cualquier temporada.",
          "Turismo activo con base urbana y acceso sencillo al Parque Nacional.",
        ],
      },
    ],
    tips: [
      "Julio y agosto son el pico de temporada de nieve: alta demanda, precios elevados, pero experiencia de nivel alto en Cerro Catedral.",
      "Noviembre a marzo permite actividades al aire libre con más horas de luz y temperatura agradable.",
      "Otoño (abril y mayo) tiene colores impresionantes y turismo más bajo: buena época para conseguir alojamientos a mejor precio.",
      "El viento patagónico puede ser intenso: conviene llevar ropa de abrigo incluso en verano.",
      "Muchas cabañas y casas en las afueras tienen vistas directas al lago o al bosque, vale la pena revisar bien la ubicación.",
    ],
    faqs: [
      {
        question: "¿Cuándo es la mejor época para ir a Bariloche?",
        answer:
          "Depende del tipo de viaje. Para ski y nieve, julio y agosto son los mejores meses. Para trekking y naturaleza, noviembre a marzo tiene más horas de luz y mayor temperatura. Otoño (abril-mayo) es ideal para quienes buscan menos gente y mejor precio.",
      },
      {
        question: "¿Qué tipos de alojamientos hay disponibles en Bariloche?",
        answer:
          "Podés encontrar cabañas en zonas boscosas o con vista al lago, departamentos en el centro urbano, casas para grupos con mayor capacidad y opciones más compactas para viajeros solos o en pareja. La variedad permite adaptarse a distintos presupuestos y estilos de viaje.",
      },
      {
        question: "¿Qué distancia hay del centro al Cerro Catedral?",
        answer:
          "Cerro Catedral está a aproximadamente 19 km del centro de Bariloche. Hay transporte público (línea 55) y opciones de remis o auto propio. Si planeás esquiar varios días, buscar alojamiento más cerca del cerro puede ser conveniente.",
      },
      {
        question: "¿Se puede visitar el Parque Nacional Nahuel Huapi desde la ciudad?",
        answer:
          "Sí. El parque rodea la ciudad y muchos senderos son accesibles en auto, bicicleta o transporte público. Circuitos como el Cerro Otto, la Cascada de los Alerces y la Isla Victoria salen directo desde Bariloche.",
      },
      {
        question: "¿Cuántos días se necesitan para conocer Bariloche?",
        answer:
          "Para una visita básica con los principales circuitos, tres o cuatro días son suficientes. Si querés hacer trekking más largo, excursiones al Tronador o paseos en kayak, una semana aprovecha bien el destino.",
      },
    ],
    relatedDestinations: [
      { slug: "mar-del-plata", name: "Mar del Plata" },
      { slug: "iguazu", name: "Iguazú" },
    ],
  },

  iguazu: {
    slug: "iguazu",
    name: "Iguazú",
    title: "Alojamientos en Puerto Iguazú | Alohar",
    metaDescription:
      "Encontrá alojamientos temporarios en Puerto Iguazú. Opciones para descubrir las Cataratas del Iguazú, la selva misionera y el turismo de naturaleza en el norte argentino.",
    canonical: "https://alohar.me/destinos/iguazu",
    eyebrow: "Destinos en Argentina",
    h1: "Alojamientos temporarios en Puerto Iguazú",
    intro:
      "Puerto Iguazú es la ciudad de acceso a las Cataratas del Iguazú, Patrimonio de la Humanidad por la UNESCO, ubicada en el extremo norte de la provincia de Misiones. El destino combina uno de los paisajes naturales más impresionantes de América del Sur con selva subtropical y una dinámica de triple frontera con Brasil y Paraguay.",
    heroImage: require("../assets/static/landing-host/water.webp"),
    searchUrl: "/iguazu/search?city=69&cityName=iguazu",
    highlights: [
      {
        title: "Las Cataratas del Iguazú",
        description:
          "El Parque Nacional Iguazú concentra más de 275 saltos de agua en un entorno selvático de 67.000 hectáreas. El circuito inferior, superior y la Garganta del Diablo son los recorridos de referencia para cualquier visita.",
      },
      {
        title: "Naturaleza y selva subtropical",
        description:
          "Más allá de las cataratas, la región tiene senderos de avistamiento de fauna, tours en lancha, actividades de canopy y experiencias en la selva misionera que complementan la visita central.",
      },
      {
        title: "Triple frontera",
        description:
          "Puerto Iguazú limita con Brasil y Paraguay, lo que permite combinar el parque argentino con la visita al lado brasileño de las cataratas y una experiencia binacional en un mismo viaje.",
      },
    ],
    sections: [
      {
        title: "Por qué ir a Iguazú",
        paragraphs: [
          "Las Cataratas del Iguazú están entre los destinos naturales más visitados de América del Sur y representan uno de los pocos lugares en Argentina que justifican un viaje específico desde cualquier punto del país. La experiencia de ver el sistema de saltos en su contexto selvático es difícil de equiparar.",
          "Puerto Iguazú tiene aeropuerto con vuelos frecuentes desde Buenos Aires, lo que permite visitas de 2 a 3 días sin necesidad de una logística compleja. La ciudad es pequeña y funcional, con una base de alojamiento orientada al viajero que llega a visitar el parque.",
        ],
      },
      {
        title: "Tipos de viaje para los que sirve Iguazú",
        bullets: [
          "Viajes de naturaleza y turismo activo con las cataratas como atractivo principal.",
          "Escapadas cortas de 2 a 4 días combinables con vuelos de bajo costo.",
          "Turismo familiar con circuitos accesibles para distintas edades.",
          "Viajes multi-destino que combinan Iguazú con Posadas, Corrientes o cruce a Brasil.",
          "Turismo educativo y de ecoturismo en la selva misionera.",
        ],
      },
    ],
    tips: [
      "El parque abre todo el año. La temporada alta coincide con julio (vacaciones de invierno) y enero-febrero.",
      "La mejor época para el caudal máximo de agua es noviembre a marzo, cuando las lluvias aumentan el volumen de los saltos.",
      "En temporada baja (mayo-junio o septiembre-octubre), el parque tiene menos visitantes y los alojamientos son más accesibles.",
      "Conviene reservar el ingreso al parque con antelación en fines de semana y feriados, ya que tiene cupo diario controlado.",
      "Si el presupuesto lo permite, visitar también el lado brasileño agrega una perspectiva panorámica completamente distinta.",
    ],
    faqs: [
      {
        question: "¿Cuántos días se necesitan para visitar las cataratas?",
        answer:
          "Con dos días cubrís bien el parque argentino (circuitos inferior, superior y Garganta del Diablo). Si sumás el lado brasileño o actividades extra en la selva, tres o cuatro días es lo ideal para no apresurarse.",
      },
      {
        question: "¿Cuándo conviene ir para ver las cataratas con más agua?",
        answer:
          "El período de noviembre a marzo tiene mayor caudal por las lluvias primaverales y estivales, lo que potencia el espectáculo visual de los saltos. El período seco (junio-agosto) puede tener menos agua pero el parque sigue siendo impresionante.",
      },
      {
        question: "¿Cómo se llega a Puerto Iguazú?",
        answer:
          "La opción más práctica desde Buenos Aires es el vuelo directo al Aeropuerto Internacional de Cataratas del Iguazú, con vuelos de menos de 2 horas. También hay conexión en ómnibus, más larga (unas 18 horas) pero más económica.",
      },
      {
        question: "¿Las cataratas tienen cupo de ingreso?",
        answer:
          "Sí. El Parque Nacional Iguazú tiene un sistema de cupos diarios para controlar el impacto ambiental. Es recomendable reservar la entrada con anticipación, especialmente en fines de semana, feriados y temporada alta.",
      },
      {
        question: "¿Vale la pena visitar también el lado brasileño?",
        answer:
          "Sí, si el tiempo lo permite. El Parque Nacional do Iguaçu brasileño ofrece una perspectiva panorámica del sistema de cataratas que no se consigue desde el lado argentino. Los dos parques son experiencias complementarias y muchos viajeros hacen los dos en el mismo viaje.",
      },
    ],
    relatedDestinations: [
      { slug: "mar-del-plata", name: "Mar del Plata" },
      { slug: "bariloche", name: "Bariloche" },
    ],
  },
};
